import { useEffect } from 'react';

export function useScrollSpySidebar() {
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.6,
    };

    const getHashFromHref = (href) => {
      const hashIndex = href.indexOf('#');
      return hashIndex !== -1 ? href.substring(hashIndex) : '';
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;

          window.history.replaceState(null, null, `#${sectionId}`);

          const activeList =
            document.querySelector("ul[id*='sidebar']:has(a.is-active)") ||
            document.querySelector("ul[id*='sidebar']");
          if (!activeList) {
            return;
          }

          activeList.querySelectorAll('a').forEach((link) => {
            link.removeAttribute('data-active');
            const linkHash = getHashFromHref(link.getAttribute('href'));
            if (linkHash === `#${sectionId}`) {
              link.setAttribute('data-active', 'true');
              link.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
              });
            }
          });
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const h2 = document.querySelectorAll('h2[id]');
    const h3 = document.querySelectorAll('h3[id]');
    const list = h2.length < 2 ? h3 : h2;

    list.forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);
}
